// extracted by mini-css-extract-plugin
export var badge = "_hq-2";
export var detailsPanel = "_hq-0";
export var resultRow = "_hq-1";